import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/hyphens}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "manual", "none", "auto");
//# sourceMappingURL=hyphens.js.map